import { HttpResponse } from '@/types/http'
import EnclosureHttp from '@/utils/http'
import { HttpConfig } from '@/utils/http/types'
import { AxiosRequestConfig, AxiosResponse } from 'axios'
import { transformBackend } from '../utils'
import { isFunction } from 'lodash'

const http = new EnclosureHttp({
  baseUrl: process.env.RVE_PROXY_URL ?? ''
})

export default function request<
  T = any,
  D = any,
  R = HttpResponse<T>,
  RF = (<_R extends AxiosResponse<any>, _T = any>(data: _R) => _T) | boolean
>(
  config: AxiosRequestConfig<D> & {
    requestConfig?: HttpConfig<T, D, AxiosResponse<R, D>>
  },
  transform?: RF
): typeof transform extends <_R extends AxiosResponse<any>, _T = any>(
  data: _R
) => _T
  ? Promise<ReturnType<typeof transform>>
  : typeof transform extends false
    ? Promise<R>
    : Promise<T> {
  let _transform = transform ?? transformBackend

  const instance = http.request<T, D, AxiosResponse<R, D>>(config)
  const customInstance = instance.then(res => {
    if (isFunction(_transform)) {
      return _transform<AxiosResponse<R, D>, T>(res)
    }
    return res
  }) as typeof transform extends <_R extends AxiosResponse<any>, _T = any>(
    data: _R
  ) => _T
    ? Promise<ReturnType<typeof transform>> & { cancel: () => any }
    : typeof transform extends false
      ? Promise<R> & { cancel: () => any }
      : Promise<T> & { cancel: () => any }
  customInstance.cancel = instance.cancel
  return customInstance
}
